import Icon from 'presentations/views/components/atoms/Icon';
import styled from '@emotion/styled';
import { memo } from 'react';
import { mediaMax, spacing } from 'presentations/views/styles';
import { black } from 'presentations/views/styles/color';

interface Props {
  shareTitle: string;
  shareUrl: string;
  direction?: 'row' | 'column';
}

const Component = memo((props: Props) => {
  const encodeUrl = encodeURIComponent(props.shareUrl);
  const encodeTitle = encodeURIComponent(props.shareTitle);
  const direction = props.direction || 'column';

  return (
    <Container direction={direction}>
      <SideShareIconLink
        direction={direction}
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeUrl}`}
      >
        <StyledIcon name="facebook" />
      </SideShareIconLink>
      <SideShareIconLink
        direction={direction}
        href={`http://twitter.com/share?text=${encodeTitle}&url=${encodeUrl}&hashtags=`}
      >
        <StyledIcon name="twitter" />
      </SideShareIconLink>
      <SideShareIconLink
        direction={direction}
        href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeUrl}&title=${encodeTitle}&summary=${''}&source=LinkedIn`}
      >
        <StyledIcon name="linkedin" />
      </SideShareIconLink>
    </Container>
  );
});

const Container = styled.div<{ direction: string }>`
  display: flex;
  flex-direction: ${(props) => props.direction};
  height: auto;
  ${mediaMax.tablet} {
    width: 100%;
    justify-content: space-evenly;
  }
`;

const SideShareIconLink = styled.a<{ direction: string }>`
  margin: ${(props) =>
    props.direction === 'column'
      ? `0 0 ${spacing(40)} 0`
      : `0 ${spacing(40)} 0 0`};
  width: 24px;
  height: 24px;
  color: ${black};
  :last-of-type {
    margin-right: 0;
    margin-bottom: 0;
  }
  ${mediaMax.tablet} {
    margin: 0;
    width: auto;
  }
`;
const StyledIcon = styled(Icon)`
  color: ${black};
  width: 28px !important;
  height: 28px !important;
`;

export default Component;
